import React, { useEffect, useState } from 'react'
import Sidebar from '../../../components/Sidebar/Sidebar';
import Header from '../../../components/Header/Header';
import './article.css'
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getArticle } from '../../../services/operations/blogs';
import { isObjectEmpty } from '../../../utils/Utils';
import Prism from "prismjs";
import "prismjs/components/prism-java";
import "prismjs/components/prism-c";
import "prismjs/components/prism-cpp";
import "prismjs/components/prism-python";

const Preview = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const params = useParams()
    const dispatch = useDispatch()
    const { blog, blogCategories } = useSelector((state) => state.blogs)

    useEffect(() => {
        Prism.highlightAll();
    }, [blog?.content]);
    useEffect(() => {
        dispatch(getArticle(params.id))
    }, [dispatch, params.id])

    function getCategoryTag(categoryId) {
        const category = blogCategories?.find(category => category?.category_id === categoryId);
        return category ? category.category_tag : 'Uncategorized'; // Return 'Uncategorized' if category is not found
    }
    useEffect(() => {
        if (blog) {
            let currentIndex = 0;
            let intervalId;
            const carousels = document.querySelectorAll('.carousel');

            carousels.forEach((carousel, idx) => {
                const images = carousel ? carousel.querySelectorAll('.carousel-image') : [];
                const leftArrow = document.querySelectorAll('.image-carousel-left-arrow')[idx];
                const rightArrow = document.querySelectorAll('.image-carousel-right-arrow')[idx];
                const controlButtons = document.querySelectorAll('.control-container-2')[idx];

                // Create and add the img-number span if it doesn't exist
                let imageNumber = controlButtons?.querySelector('.img-number');
                if (!imageNumber) {
                    imageNumber = document.createElement('span');
                    imageNumber.className = 'img-number';
                    controlButtons.insertBefore(imageNumber, rightArrow);
                }

                function updateCarousel() {
                    if (carousel) {
                        carousel.style.transform = `translateX(-${currentIndex * 100}%)`;
                    }
                    updateImageNumber();
                }

                function nextImage() {
                    currentIndex = (currentIndex + 1) % images.length;
                    updateCarousel();
                }

                function prevImage() {
                    currentIndex = (currentIndex - 1 + images.length) % images.length;
                    updateCarousel();
                }


                function updateImageNumber() {
                    if (imageNumber) {
                        imageNumber.textContent = `${currentIndex + 1}/${images.length}`;
                    }
                }

                // Only add event listeners if they haven't been added yet
                if (leftArrow && !leftArrow.classList.contains('event-attached')) {
                    leftArrow.classList.add('event-attached');
                    leftArrow.addEventListener('click', prevImage);
                }

                if (rightArrow && !rightArrow.classList.contains('event-attached')) {
                    rightArrow.classList.add('event-attached');
                    rightArrow.addEventListener('click', nextImage);
                }

                updateCarousel();

                return () => {
                    if (leftArrow) leftArrow.removeEventListener('click', prevImage);
                    if (rightArrow) rightArrow.removeEventListener('click', nextImage);
                    clearInterval(intervalId);
                };
            });
        }
    }, [blog]);

    // Carousel Modal Open Button
    //   useEffect(() => {
    //     if (studyViewProblemEditorial) {
    //       const carousels = document.querySelectorAll('.carousel');
    //       carousels.forEach((carousel, idx) => {
    //         const downButton = document.querySelectorAll('.image-carousel-down-button')[idx];
    //         if (downButton) {
    //           downButton.setAttribute('data-tooltip-id', 'Open-Modal');
    //           downButton.setAttribute('data-tooltip-content', 'Open Modal');
    //           downButton.setAttribute('data-tooltip-place', 'top');

    //           // Only add event listener if it hasn't been added yet
    //           if (!downButton.classList.contains('event-attached')) {
    //             downButton.classList.add('event-attached');
    //             downButton.addEventListener('click', (e) => {
    //               e.stopPropagation();
    //               const images = carousel.querySelectorAll('.carousel-image img');
    //               const imageSrcs = Array.from(images).map((img) => img.src);
    //               setImagesModalOpen(true);
    //               setProblemImages(imageSrcs);
    //             });
    //           }

    //           const controlButtons = document.querySelectorAll('.control-container')[idx];
    //           controlButtons.appendChild(downButton);
    //         }
    //       });
    //     }
    //   }, [studyViewProblemEditorial]);

    useEffect(() => {
        const codeSections = document.querySelectorAll(".code-section");
        // Get last selected language from localStorage or set default value
        let lastSelectedLanguage =
            localStorage.getItem("lastSelectedLanguage") || "cpp";

        codeSections.forEach((section, sectionIndex) => {
            const codeTabs = section.querySelectorAll(".code-tab");
            const codeBlocks = section.querySelectorAll(".code-block");
            const copyBtn = section.querySelector(".copy-btn");
            const cpb = section.querySelector(".copy-button")

            if (copyBtn) copyBtn?.remove()


            codeTabs.forEach(
                (tab) => {
                    tab.addEventListener("click", () => {
                        codeTabs.forEach((t) => {
                            t.classList.remove("dsa_article_code_active");
                        });
                        tab.classList.add("dsa_article_code_active");

                        const lang = tab.dataset.lang;
                        const activeBlock = section.querySelector(
                            `.code-block[data-lang="${lang}"]`
                        );
                        codeBlocks.forEach((block) => {
                            if (block === activeBlock) {
                                block.classList.add("dsa_article_code_active");
                            } else {
                                block.classList.remove("dsa_article_code_active");
                            }
                        });

                        // Update last selected language for all sections and store in localStorage
                        lastSelectedLanguage = lang;
                        localStorage.setItem("lastSelectedLanguage", lang);
                        codeSections.forEach((otherSection, otherIndex) => {
                            if (otherIndex !== sectionIndex) {
                                const otherTabs = otherSection.querySelectorAll(".code-tab");
                                otherTabs.forEach((otherTab) => {
                                    if (otherTab.dataset.lang === lang) {
                                        otherTab.classList.add("dsa_article_code_active");
                                    } else {
                                        otherTab.classList.remove("dsa_article_code_active");
                                    }
                                });
                                const otherActiveBlock = otherSection.querySelector(
                                    `.code-block[data-lang="${lang}"]`
                                );
                                const otherCodeBlocks =
                                    otherSection.querySelectorAll(".code-block");
                                otherCodeBlocks.forEach((block) => {
                                    if (block === otherActiveBlock) {
                                        block.classList.add("dsa_article_code_active");
                                    } else {
                                        block.classList.remove("dsa_article_code_active");
                                    }
                                });
                            }
                        });
                    });
                },
                [blog?.content]
            );

            if (cpb) {
                // Handle copy button click event
                cpb.addEventListener("click", () => {
                    const activeBlock = section.querySelector(
                        ".code-block.dsa_article_code_active code"
                    );
                    if (activeBlock) navigator.clipboard.writeText(activeBlock.innerText);
                    // console.log(activeBlock.innerText)
                    // cpb.classList.add("dsa_article_code_active");
                    // setTimeout(() => {
                    //     cpb.classList.remove("dsa_article_code_active");
                    // }, 1000);
                });
            }
        });


        // Set initial state of the tabs
        codeSections.forEach((section) => {
            const codeTabs = section.querySelectorAll(".code-tab");
            const codeBlocks = section.querySelectorAll(".code-block");

            codeTabs.forEach((tab) => {
                if (tab.dataset.lang === lastSelectedLanguage) {
                    tab.classList.add("dsa_article_code_active");
                } else {
                    tab.classList.remove("dsa_article_code_active");
                }
            });

            codeBlocks.forEach((block) => {
                if (block.dataset.lang === lastSelectedLanguage) {
                    block.classList.add("dsa_article_code_active");
                } else {
                    block.classList.remove("dsa_article_code_active");
                }
            });
        });
    });
    useEffect(() => {

        const handleClick = (e) => {
            e.preventDefault();
            const target = e.target.hash;
            const element = document.querySelector(target);
            const bruteForceAlgorithmDetails = document.querySelector('#brute-force-approach details').querySelector('details');
            const betterAlgorithmDetails = document.querySelector('#better-approach details').querySelector('details');
            const optimalAlgorithmDetails = document.querySelector('#optimal-approach details').querySelector('details');
            const details = document.querySelectorAll('details');
            const videoDetails = document.querySelector("#dsa_article_video_explanation").querySelector('details')

            for (let j = 0; j < details.length; j++) {
                if (details[j].querySelector(`a[href="${target}"]`) === null) {
                    details[j].removeAttribute('open');
                    details[j].querySelector('summary').classList.remove('active');
                }
            }

            element?.querySelector('details')?.setAttribute('open', true);
            bruteForceAlgorithmDetails.setAttribute('open', true);
            betterAlgorithmDetails.setAttribute('open', true);
            videoDetails.setAttribute('open', true);
            optimalAlgorithmDetails.setAttribute('open', true);

            const links = document.querySelectorAll('a[href^="#"]');
            for (let j = 0; j < links.length; j++) {
                if (links[j].hash === target) {
                    links[j].classList.add('actively');
                    setTimeout(() => {
                        links[j].classList.remove('actively');
                    }, 3000);
                } else {
                    links[j].classList.remove('actively');
                }
            }


        };

        const links = document.querySelectorAll('a[href^="#"]');
        links.forEach(link => link.addEventListener('click', handleClick));

        return () => {
            links.forEach(link => link.removeEventListener('click', handleClick));
        };
    });

    useEffect(() => {
        const listeners = [];

        document
            .querySelectorAll('details.code-section')
            .forEach(detailsElement => {
                if (!detailsElement) return;

                const onToggle = () => {
                    const codeTabs = detailsElement.querySelector('.code-tabs');
                    if (!codeTabs) return;

                    if (detailsElement.open) {
                        // only add if the container doesn't already exist
                        if (!codeTabs.querySelector('.copy-view-container')) {
                            const container = document.createElement('div');
                            container.className = 'copy-view-container';

                            const copyButton = document.createElement('button');
                            copyButton.className = 'copy-button';
                            copyButton.innerHTML = `
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.79331 13.125C6.41444 13.125 6.09375 12.9938 5.83125 12.7313C5.56875 12.4688 5.4375 12.1481 5.4375 11.7692V3.23081C5.4375 2.85194 5.56875 2.53125 5.83125 2.26875C6.09375 2.00625 6.41444 1.875 6.79331 1.875H13.0817C13.4606 1.875 13.7812 2.00625 14.0438 2.26875C14.3063 2.53125 14.4375 2.85194 14.4375 3.23081V11.7692C14.4375 12.1481 14.3063 12.4688 14.0438 12.7313C13.7812 12.9938 13.4606 13.125 13.0817 13.125H6.79331ZM6.79331 12H13.0817C13.1394 12 13.1923 11.9759 13.2403 11.9278C13.2884 11.8798 13.3125 11.8269 13.3125 11.7692V3.23081C13.3125 3.17306 13.2884 3.12019 13.2403 3.07219C13.1923 3.02406 13.1394 3 13.0817 3H6.79331C6.73556 3 6.68269 3.02406 6.63469 3.07219C6.58656 3.12019 6.5625 3.17306 6.5625 3.23081V11.7692C6.5625 11.8269 6.58656 11.8798 6.63469 11.9278C6.68269 11.9759 6.73556 12 6.79331 12ZM4.16831 15.75C3.78944 15.75 3.46875 15.6188 3.20625 15.3563C2.94375 15.0938 2.8125 14.7731 2.8125 14.3942V5.29331C2.8125 5.13369 2.86637 5 2.97412 4.89225C3.08175 4.78462 3.21538 4.73081 3.375 4.73081C3.53463 4.73081 3.66831 4.78462 3.77606 4.89225C3.88369 5 3.9375 5.13369 3.9375 5.29331V14.3942C3.9375 14.4519 3.96156 14.5048 4.00969 14.5528C4.05769 14.6009 4.11056 14.625 4.16831 14.625H11.0192C11.1788 14.625 11.3125 14.6788 11.4203 14.7864C11.5279 14.8942 11.5817 15.0279 11.5817 15.1875C11.5817 15.3471 11.5279 15.4808 11.4203 15.5884C11.3125 15.6961 11.1788 15.75 11.0192 15.75H4.16831Z" fill="#919EAB"/>
                    </svg>`;

                            const viewButton = document.createElement('button');
                            viewButton.className = 'view-button';
                            viewButton.innerHTML = `
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.98081 15.375C3.60194 15.375 3.28125 15.2438 3.01875 14.9813C2.75625 14.7188 2.625 14.3981 2.625 14.0192V3.98081C2.625 3.60194 2.75625 3.28125 3.01875 3.01875C3.28125 2.75625 3.60194 2.625 3.98081 2.625H8.14894C8.30856 2.625 8.44225 2.67887 8.55 2.78662C8.65763 2.89425 8.71144 3.02788 8.71144 3.1875C8.71144 3.34713 8.65763 3.48075 8.55 3.58838C8.44225 3.69613 8.30856 3.75 8.14894 3.75H3.98081C3.92306 3.75 3.87019 3.77406 3.82219 3.82219C3.77406 3.87019 3.75 3.92306 3.75 3.98081V14.0192C3.75 14.0769 3.77406 14.1298 3.82219 14.1778C3.87019 14.2259 3.92306 14.25 3.98081 14.25H14.0192C14.0769 14.25 14.1298 14.2259 14.1778 14.1778C14.2259 14.1298 14.25 14.0769 14.25 14.0192V9.85106C14.25 9.69144 14.3039 9.55775 14.4116 9.45C14.5192 9.34238 14.6529 9.28856 14.8125 9.28856C14.9721 9.28856 15.1058 9.34238 15.2134 9.45C15.3211 9.55775 15.375 9.69144 15.375 9.85106V14.0192C15.375 14.3981 15.2438 14.7188 14.9813 14.9813C14.7188 15.2438 14.3981 15.375 14.0192 15.375H3.98081ZM14.25 4.54031L7.68469 11.1058C7.58081 11.2096 7.45025 11.2627 7.293 11.2652C7.13588 11.2676 7.00294 11.2144 6.89419 11.1058C6.78556 10.9971 6.73125 10.8653 6.73125 10.7106C6.73125 10.5558 6.78556 10.4241 6.89419 10.3153L13.4597 3.75H11.0625C10.9029 3.75 10.7692 3.69613 10.6616 3.58838C10.5539 3.48075 10.5 3.34713 10.5 3.1875C10.5 3.02788 10.5539 2.89425 10.6616 2.78662C10.7692 2.67887 10.9029 2.625 11.0625 2.625H14.697C14.8904 2.625 15.0517 2.68969 15.1809 2.81906C15.3103 2.94831 15.375 3.10962 15.375 3.303V6.9375C15.375 7.09713 15.3211 7.23075 15.2134 7.33838C15.1058 7.44613 14.9721 7.5 14.8125 7.5C14.6529 7.5 14.5192 7.44613 14.4116 7.33838C14.3039 7.23075 14.25 7.09713 14.25 6.9375V4.54031Z" fill="#919EAB"/>
                    </svg>`;
                            viewButton.addEventListener('click', e => {
                                e.preventDefault();
                                e.stopPropagation();
                                const codeBlock = detailsElement.querySelector(
                                    '.code-block.dsa_article_code_active pre code'
                                );
                                if (codeBlock) {
                                    // setActiveCodeContent(codeBlock.innerText);
                                    // setActiveCodeLang(codeBlock.getAttribute('lang'));
                                    // setIsModalOpen(true);
                                }
                            });

                            container.append(copyButton, viewButton);
                            codeTabs.appendChild(container);
                        }
                    } else {
                        // remove the entire container on close
                        const old = codeTabs.querySelector('.copy-view-container');
                        if (old) old.remove();
                    }
                };

                detailsElement.addEventListener('toggle', onToggle);
                listeners.push({ detailsElement, onToggle });
            });

        return () => {
            listeners.forEach(({ detailsElement, onToggle }) => {
                detailsElement.removeEventListener('toggle', onToggle);
            });
        };
    }, [blog?.content]);

    useEffect(() => {
        const codeSections = document.querySelectorAll('.code-section');
        // Get last selected language from localStorage or set default value
        let lastSelectedLanguage = localStorage.getItem('lastSelectedLanguage') || 'cpp';

        codeSections.forEach((section, sectionIndex) => {
            const codeTabs = section.querySelectorAll('.code-tab');
            const codeBlocks = section.querySelectorAll('.code-block');
            const copyBtn = section.querySelector('.copy-btn');
            const cpb = section.querySelector('.copy-button');

            if (copyBtn) copyBtn?.remove();

            codeTabs.forEach(
                (tab) => {
                    tab.addEventListener('click', () => {
                        codeTabs.forEach((t) => {
                            t.classList.remove('dsa_article_code_active');
                        });
                        tab.classList.add('dsa_article_code_active');

                        const lang = tab.dataset.lang;
                        const activeBlock = section.querySelector(`.code-block[data-lang="${lang}"]`);
                        codeBlocks.forEach((block) => {
                            if (block === activeBlock) {
                                block.classList.add('dsa_article_code_active');
                            } else {
                                block.classList.remove('dsa_article_code_active');
                            }
                        });

                        // Update last selected language for all sections and store in localStorage
                        lastSelectedLanguage = lang;
                        localStorage.setItem('lastSelectedLanguage', lang);
                        codeSections.forEach((otherSection, otherIndex) => {
                            if (otherIndex !== sectionIndex) {
                                const otherTabs = otherSection.querySelectorAll('.code-tab');
                                otherTabs.forEach((otherTab) => {
                                    if (otherTab.dataset.lang === lang) {
                                        otherTab.classList.add('dsa_article_code_active');
                                    } else {
                                        otherTab.classList.remove('dsa_article_code_active');
                                    }
                                });
                                const otherActiveBlock = otherSection.querySelector(
                                    `.code-block[data-lang="${lang}"]`,
                                );
                                const otherCodeBlocks = otherSection.querySelectorAll('.code-block');
                                otherCodeBlocks.forEach((block) => {
                                    if (block === otherActiveBlock) {
                                        block.classList.add('dsa_article_code_active');
                                    } else {
                                        block.classList.remove('dsa_article_code_active');
                                    }
                                });
                            }
                        });
                    });
                },
                [blog?.content],
            );

            if (cpb) {
                document.addEventListener('click', function (event) {
                    const copyButton = event.target.closest('.copy-button');
                    if (copyButton) {
                        const section = copyButton.closest('.code-section');
                        const activeBlock = section.querySelector('.code-block.dsa_article_code_active pre');
                        if (activeBlock) {
                            navigator.clipboard
                                .writeText(activeBlock.innerText)
                                .then(() => {
                                    copyButton.textContent = 'Copied';
                                    setTimeout(() => {
                                        copyButton.innerHTML = `
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.79331 13.125C6.41444 13.125 6.09375 12.9938 5.83125 12.7313C5.56875 12.4688 5.4375 12.1481 5.4375 11.7692V3.23081C5.4375 2.85194 5.56875 2.53125 5.83125 2.26875C6.09375 2.00625 6.41444 1.875 6.79331 1.875H13.0817C13.4606 1.875 13.7812 2.00625 14.0438 2.26875C14.3063 2.53125 14.4375 2.85194 14.4375 3.23081V11.7692C14.4375 12.1481 14.3063 12.4688 14.0438 12.7313C13.7812 12.9938 13.4606 13.125 13.0817 13.125H6.79331ZM6.79331 12H13.0817C13.1394 12 13.1923 11.9759 13.2403 11.9278C13.2884 11.8798 13.3125 11.8269 13.3125 11.7692V3.23081C13.3125 3.17306 13.2884 3.12019 13.2403 3.07219C13.1923 3.02406 13.1394 3 13.0817 3H6.79331C6.73556 3 6.68269 3.02406 6.63469 3.07219C6.58656 3.12019 6.5625 3.17306 6.5625 3.23081V11.7692C6.5625 11.8269 6.58656 11.8798 6.63469 11.9278C6.68269 11.9759 6.73556 12 6.79331 12ZM4.16831 15.75C3.78944 15.75 3.46875 15.6188 3.20625 15.3563C2.94375 15.0938 2.8125 14.7731 2.8125 14.3942V5.29331C2.8125 5.13369 2.86637 5 2.97412 4.89225C3.08175 4.78462 3.21538 4.73081 3.375 4.73081C3.53463 4.73081 3.66831 4.78462 3.77606 4.89225C3.88369 5 3.9375 5.13369 3.9375 5.29331V14.3942C3.9375 14.4519 3.96156 14.5048 4.00969 14.5528C4.05769 14.6009 4.11056 14.625 4.16831 14.625H11.0192C11.1788 14.625 11.3125 14.6788 11.4203 14.7864C11.5279 14.8942 11.5817 15.0279 11.5817 15.1875C11.5817 15.3471 11.5279 15.4808 11.4203 15.5884C11.3125 15.6961 11.1788 15.75 11.0192 15.75H4.16831Z" fill="#919EAB"/>
                        </svg>`;
                                    }, 2000);
                                })
                                .catch((error) => {
                                    console.error('Unable to copy text: ', error);
                                    // Optionally, handle the error here
                                });
                        }
                    }
                });
            }
        });

        // Set initial state of the tabs
        codeSections.forEach((section) => {
            const codeTabs = section.querySelectorAll('.code-tab');
            const codeBlocks = section.querySelectorAll('.code-block');

            codeTabs.forEach((tab) => {
                if (tab.dataset.lang === lastSelectedLanguage) {
                    tab.classList.add('dsa_article_code_active');
                } else {
                    tab.classList.remove('dsa_article_code_active');
                }
            });

            codeBlocks.forEach((block) => {
                if (block.dataset.lang === lastSelectedLanguage) {
                    block.classList.add('dsa_article_code_active');
                } else {
                    block.classList.remove('dsa_article_code_active');
                }
            });
        });
    });
    useEffect(() => {
        const handleClick = (e) => {
            e.preventDefault();
            const target = e.target.hash;
            const element = document.querySelector(target);
            const bruteForceAlgorithmDetails = document
                .querySelector('#brute-force-approach details')
                .querySelector('details');
            const betterAlgorithmDetails = document
                .querySelector('#better-approach details')
                .querySelector('details');
            const optimalAlgorithmDetails = document
                .querySelector('#optimal-approach details')
                .querySelector('details');
            const details = document.querySelectorAll('details');
            const videoDetails = document
                .querySelector('#dsa_article_video_explanation')
                .querySelector('details');

            for (let j = 0; j < details.length; j++) {
                if (details[j].querySelector(`a[href="${target}"]`) === null) {
                    details[j].removeAttribute('open');
                    details[j].querySelector('summary').classList.remove('active');
                }
            }

            element?.querySelector('details')?.setAttribute('open', true);
            bruteForceAlgorithmDetails.setAttribute('open', true);
            betterAlgorithmDetails.setAttribute('open', true);
            videoDetails.setAttribute('open', true);
            optimalAlgorithmDetails.setAttribute('open', true);

            const links = document.querySelectorAll('a[href^="#"]');
            for (let j = 0; j < links.length; j++) {
                if (links[j].hash === target) {
                    links[j].classList.add('actively');
                    setTimeout(() => {
                        links[j].classList.remove('actively');
                    }, 3000);
                } else {
                    links[j].classList.remove('actively');
                }
            }
            // handleScroll(element);
        };

        const links = document.querySelectorAll('a[href^="#"]');
        links.forEach((link) => link.addEventListener('click', handleClick));

        return () => {
            links.forEach((link) => link.removeEventListener('click', handleClick));
        };
    });

    useEffect(() => {
        if (blog && !isObjectEmpty(blog)) {
            const codeTabs = document.querySelectorAll('.code-tabs');

            codeTabs.forEach((codeTab) => {
                // Create language container

                const langContainer = document.createElement('div');
                langContainer.classList.add('lang-container');

                const children = Array.from(codeTab.children);

                if (children.length > 1) {
                    children.forEach((child) => {
                        if (
                            !child.classList.contains('copy-button') &&
                            !child.classList.contains('copy-view-container')
                        ) {
                            langContainer.appendChild(child);
                        }
                    });
                }

                // // Create copy-view container
                // const copyViewContainer = document.createElement('div');
                // copyViewContainer.classList.add('copy-view-container');

                // // Find copy button more specifically
                // const copyBtn = codeTab.querySelector('.copy-button');

                // if (copyBtn) {
                //   // Clone the copy button
                //   const clonedCopyBtn = copyBtn.cloneNode(true);

                //   // Create view button
                //   const viewBtn = document.createElement('div');
                //   viewBtn.classList.add('view-button');
                //   viewBtn.textContent = 'View';

                //   // Append buttons to copy-view container
                //   copyViewContainer.appendChild(clonedCopyBtn);
                //   copyViewContainer.appendChild(viewBtn);

                //   // Remove original copy button
                //   copyBtn.remove();
                // }

                // Append containers to code tab
                codeTab.appendChild(langContainer);
                // codeTab.appendChild(copyViewContainer);
            });
        }
    }, [blog]);


    useEffect(() => {
        if (blog && !isObjectEmpty(blog)) {
            // Use a small timeout to ensure the DOM is fully rendered
            const practise = document.querySelectorAll('.practice');
            // Update existing practice elements
            practise.forEach((p) => {
                p.innerHTML = ``;
            });
        }
    }, [blog]);

    useEffect(() => {
        if (blog && !isObjectEmpty(blog) && blog.tuf_plus) {
            let insertAfters = [
                ...document.querySelectorAll('.has-accent-color'),
                ...document.querySelectorAll('.new-disclaimer'),
                ...document.querySelectorAll(".has-vivid-red-color")
            ];
            if (!insertAfters.length) {
                insertAfters = [...document.querySelectorAll('.plusLink')];
            }

            insertAfters.forEach((insertAfter) => {
                const container = document.createElement('div');
                container.classList.add('practice');
                container.classList.add('article');
                container.classList.add('mt-4');
                container.classList.add('flex');
                container.classList.add('items-end');
                container.innerHTML = `
              <span class="mr-3">Practice: </span>
              <a target="window" href="${blog.tuf_plus}" class="tuf_plus_practise"><span>Solve Problem</span>
              <svg width="36" height="12" viewBox="0 0 40 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_2103_14522)">
              <path d="M1.82031 3.80509H5.87659L4.3363 11.7507H7.5835L9.00229 3.80509H12.9713L13.2779 2.24951H2.12954L1.82031 3.80509Z" fill="white"/>
              <path d="M14.3024 2.24951L13.04 9.36055L15.0125 11.7507H23.6926L25.3497 2.24951H22.1738L20.7732 10.1693H16.8275L16.1963 9.39984L17.4194 2.24951H14.3024Z" fill="white"/>
              <path d="M24.7617 11.7507H27.8892L28.396 8.5744H36.3117L36.6261 6.99991H28.6932L29.0599 4.60797L29.9861 3.78653H34.0228L33.7081 5.41159H36.8709L37.43 2.24951H28.7805L26.0022 4.62544L24.7617 11.7507Z" fill="white"/>
              </g>
              <defs>
              <clipPath id="clip0_2103_14522">
              <rect width="35.6095" height="9.50119" fill="white" transform="translate(1.82031 2.24951)"/>
              </clipPath>
              </defs>
              </svg>
              </a>`;
                // const anchor = container.querySelector('.tuf_plus_practise');


                // Insert the container AFTER the insertAfter element
                if (insertAfter.parentNode) {
                    insertAfter.parentNode.insertBefore(container, insertAfter.nextSibling);
                }
            });
        }
    }, [blog]);

    useEffect(() => {
        if (blog && !isObjectEmpty(blog)) {
            const blockQuote = document.querySelectorAll('.wp-block-quote');

            if (blockQuote.length > 0) {
                blockQuote.forEach((bq) => {
                    const text = bq.innerHTML;

                    const cutoffPhrase = 'If you also wish to share your knowledge';
                    const cutoffIndex = text.indexOf(cutoffPhrase);

                    if (cutoffIndex !== -1) {
                        // Get everything before the cutoff phrase
                        const firstPart = text.substring(0, cutoffIndex);
                        bq.innerHTML = firstPart;
                    }
                });
            }
        }
    }, [blog]);


    return (
        <div className="flex bg-[#fafafa] dark:bg-dark  h-screen overflow-hidden">
            <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
                <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                <main>
                    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
                        {blog && !isObjectEmpty(blog) ? (
                            <div className='flex flex-col'>
                                <div className='flex flex-col gap-y-3 items-start'>
                                    {/* <span className='text-sm text-gray-500 font-medium '>{blog?.publishedOn}</span>
                                    <div className='w-1 h-1 rounded-full bg-gray-400'></div> */}
                                    <span className='text-sm text-gray-500 font-medium'>Category : {getCategoryTag(blog?.category_id)}</span>
                                    <span className='text-sm text-gray-500 font-medium'>Slug: {blog?.slug}</span>
                                    <span className='text-sm text-gray-500 font-medium'>Topics: {blog?.topics?.label}</span>
                                </div>
                                <div className='flex sm:flex-row flex-col justify-between items-center'>
                                    <p className='text-[36px] font-bold'>{blog?.title}</p>
                                </div>

                                <div className="text-lg mt-4 font-medium text-zinc-800 dark:text-zinc-200 article" dangerouslySetInnerHTML={{ __html: blog?.content }} />



                                {blog?.video && (
                                    <div className='mt-4 flex justify-center items-center'>
                                        <iframe class="lazy-loaded" loading="lazy" width="810" height="456" data-lazy-type="iframe" data-src={`https://www.youtube.com/embed/${blog?.video}`} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen="" src={`https://www.youtube.com/embed/${blog?.video}`}></iframe><noscript><iframe loading="lazy" width="810" height="456" src={`https://www.youtube.com/embed/${blog?.video}`} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen=""></iframe></noscript>
                                    </div>
                                )}
                            </div>
                        ) : (null)}
                    </div>
                </main>
            </div>
        </div>
    )
}

export default Preview